import React from "react";
import styled from "styled-components/macro";
import { RootState } from "../../store/rootState";
import { useSelector } from "react-redux";
import { NativeActions, UserInfo } from "../../communication/PlatformActions";
import { platformActions } from "../../communication/Communication";
import { App } from "../../app";
import Button from "../shared/Button";
import { Icon } from '@fluentui/react/lib/Icon';

export default function ChooseAccount(): JSX.Element {
    const state = useSelector((state: RootState) => state.appState);
    const emptyPng = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
    const users: UserInfo[] = state.accounts;

    // uncomment for debugging
    // let users: UserInfo[] = state.accounts;
    // users = [
    //     { name: "Nikola Mihaylov", email: "nikolami@microsoft.com" } as UserInfo,
    //     { name: "Nikola Mihaylov", email: "nikolami@pme.gbl.msidentity.com" } as UserInfo,
    // ];

    function onClick(user: UserInfo): void {
        const native: NativeActions = platformActions.getNativeActions();
        native.chooseAccount(user.vsid);
        App.signInComplete(user, false);
    }

    function onSignInClick(): void {
        App.requestSignOutAndIn();
    }

    return <Wrapper>
        <div>
            <h1>Pick an account</h1>
            <AccountsWrapper>
                {users && users.map((user, i) => (
                    <UserButton key={i} buttonType="normal" onClick={() => onClick(user)}>
                        <ButtonContentWrapper>
                            <img className="profile-image" src={user.logo ?? emptyPng} alt={`${user.name} avatar`}></img>
                            <div css="flex-grow: 1; padding-right: 2rem;">
                                <h2>{user.email}</h2>
                                <div>{user.name}</div>
                            </div>
                            <Icon className="icon" iconName="ChevronRight" />
                        </ButtonContentWrapper>
                    </UserButton>
                ))}

                <UserButton key="signIn" buttonType="normal" onClick={onSignInClick}>
                    <ButtonContentWrapper>
                        <div css="flex-grow: 1; padding-right: 2rem;">
                            <div>Use another account</div>
                        </div>
                        <Icon className="icon" iconName="ChevronRight" />
                    </ButtonContentWrapper>
                </UserButton>
            </AccountsWrapper>
        </div>
    </Wrapper>
}

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-items: center;
    padding: 6rem 5rem 10rem 5rem;

    & * {
        font-size: 1.6rem;
    }
`;

const UserButton = styled(Button)`
    display: flex;
    flex-direction: row;
    margin-bottom: 2rem;

    text-align: left;
    &.btn-normal {
        border-width: .1rem;
    }
`;

const ButtonContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    padding: 3rem 2rem;
    flex-grow: 1;
    
    .profile-image {
        width: 5rem;
        height: auto;
        margin-right: 1.2rem;
        border-radius: 50%;
        object-fit: contain;
    }
`;

const AccountsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 3rem 0;
`;
